import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanRepartDepenses(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Répartition des dépenses " + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de fonctionnement');

        var ComEpci = null;
        if (props.user.id_organisme_type === '1') {
            ComEpci = 'Com';
        }
        else if (props.user.id_organisme_type === '2') {
            ComEpci = 'Epci';
        }
        else if (props.user.id_organisme_type === '3') {
            ComEpci = 'Com';
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'bar',
                height: 350,
                stacked: true,
                stackType: '100%',
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            plotOptions: {
                bar: {
                    borderRadius: 4
                },
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true) + "%";
                  }
                },
            },
            fill: {
              opacity: 1
            }
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'depensesGestion': true,
            'ComEpci': ComEpci,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
            'hypothese': 'R',
            'ba': props.user.budget_annexe,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {
            if (props.user.budget_annexe == 1) {
                await setSeries([{
                    name: "Charges de personnel",
                    data: res.data[0],
                    color: '#e74c3c',
                    type: 'column',
                },{
                    name: "Charges à caractère général",
                    data: res.data[1],
                    color: '#95a5a6',
                    type: 'column'
                },{
                    name: "Autres charges d'exploitation",
                    data: res.data[7],
                    color: '#009432',
                    type: 'column'
                }])
            }
            else {
                await setSeries([{
                    name: "Charges de personnel",
                    data: res.data[0],
                    color: '#e74c3c',
                    type: 'column',
                },{
                    name: "Charges à caractère général",
                    data: res.data[1],
                    color: '#95a5a6',
                    type: 'column'
                },{
                    name: "Attribution de compensation",
                    data: res.data[2],
                    color: '#8e44ad',
                    type: 'column'
                },{
                    name: "Dotation de solidarité communautaire",
                    data: res.data[3],
                    color: '#D980FA',
                    type: 'column'
                },{
                    name: "Contributions et participations",
                    data: res.data[4],
                    color: '#fff200',
                    type: 'column'
                },{
                    name: "Subventions versées",
                    data: res.data[5],
                    color: '#2ecc71',
                    type: 'column'
                },{
                    name: "Déficits des budgets annexes",
                    data: res.data[6],
                    color: '#2c3e50',
                    type: 'column'
                },{
                    name: "Autres charges de gestion",
                    data: res.data[7],
                    color: '#009432',
                    type: 'column'
                }])
            }
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="bar"
            />:null}
		</div>
	)
}

export default BilanRepartDepenses;
